import React from 'react';
import { LeasingRateCellProps } from './leasing-rate-cell.types';
import { getPriceAndFuelCost } from '../../../product/utils';
import useLatestEvents from '../../../../hooks/use-latest-events';
import { OFFER_STATUSES } from '../../../../constants';
import useOfferStatus from '../../../../hooks/react-query/use-offer-status';
import useCheckPage from '../../../../hooks/use-check-page';
import toMoney from '../../../../utils/toMoney';

const LeasingRateCell = ({ row }: LeasingRateCellProps) => {
  const { globalReferenceVehicleGeneratedViaAPIEvent } = useLatestEvents(row?.events || []);
  const isGlobalReferenceVehicle = !!globalReferenceVehicleGeneratedViaAPIEvent;

  const { isEmployeeConfigurationsPage, isNewEmployeeConfigurationsPage, isNewDriverConfigurationPage } =
    useCheckPage();

  const { offerStatus } = useOfferStatus(
    row?.events || [],
    isEmployeeConfigurationsPage || isNewEmployeeConfigurationsPage,
    isNewDriverConfigurationPage
  );
  const isOrderCompleted = [OFFER_STATUSES.orderCompleted].includes(offerStatus);

  const { priceWithoutFuelCost } = getPriceAndFuelCost(isGlobalReferenceVehicle, isOrderCompleted, row);

  return <div>{priceWithoutFuelCost ? toMoney(priceWithoutFuelCost) : '-'}</div>;
};

export default LeasingRateCell;
